<template>
  <v-row no-gutters>
    <v-col cols="4" class="d-flex flex-column align-center justify-center">
      <v-sheet class="text-left">
        <div>
          <span class="text-primary text-overline pr-4">
            {{ `${$t("labels.kpi-type").toUpperCase()}` }}
          </span>
          <span class="text-secondary font-weight-bold">
            {{ `${$t("labels." + kpiType.toLowerCase())}` }}
          </span>
        </div>

        <span class="text-overline pr-4">
          {{ $t("labels.kpi-type-values") }}
        </span>
        <span class="font-weight-medium text-secondary">
          {{ `${$t("labels." + valueType.toLowerCase())}` }}
        </span>
      </v-sheet>
    </v-col>
    <v-col cols="4" class="text-center d-flex align-start justify-center">
      <v-sheet class="text-center pt-0"> </v-sheet>
    </v-col>
    <v-col cols="4" class="text-center d-flex align-center justify-center">
      <v-sheet class="text-left">
        <span class="text-primary text-overline pr-4">
          {{ $t("strings.last-update") }}
        </span>
        <span class="text-secondary font-weight-bold">
          {{ lastValue !== null && lastValue !== undefined ? lastValue : '-' }}
        </span>
        <br />
        <span class="text-primary text-overline pr-4">
          {{ $t("strings.on-date") }}
        </span>
        <span class="text-secondary font-weight-bold">
          {{ lastUpdate ? formatDate(lastUpdate) : '-' }}
        </span>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import { formatDateToLocale } from "../composables/fetchChartData.js";
export default {
  name: "StatusManual",
  props: {
    kpiType: {
      type: String,
      required: true,
    },
    valueType: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    lastValue() {
      const kpi = this.getKpiFromSession();
      const manualInput = kpi?.definition?.manualInput || [];
      
      if (manualInput.length === 0) return null;
      
      const lastEntry = manualInput[manualInput.length - 1];
      return lastEntry?.value !== undefined ? lastEntry.value : null;
    },
    lastUpdate() {
      const kpi = this.getKpiFromSession();
      const manualInput = kpi?.definition?.manualInput || [];
      
      if (manualInput.length === 0) return '';
      
      const lastEntry = manualInput[manualInput.length - 1];
      return lastEntry?.timestamp || '';
    },
  },
  methods: {
    getKpiFromSession() {
      try {
        const raw = sessionStorage.getItem("kpi");
        return raw ? JSON.parse(raw) : {};
      } catch (e) {
        console.error("Error reading KPI from session storage:", e);
        return {};
      }
    },
    formatDate(dateString) {
      return formatDateToLocale(dateString);
    },
  },
};
</script>
